import { render, staticRenderFns } from "./binc_result.vue?vue&type=template&id=b3259622&"
import script from "./binc_result.vue?vue&type=script&lang=js&"
export * from "./binc_result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports